export const isInitialValid = (formProps) => {
  if (!formProps.validationSchema) return true;
  return formProps.validationSchema.isValidSync(formProps.initialValues);
};
